import React from 'react';
import { FileIcon, fileColor, fmtSize } from '../Common/fileKind';

/* Файлы номера у ученика — компактные стеклянные карточки в ряд: цветная
   иконка типа, имя, под ним размер и кнопка скачивания.
   Локальные файлы (/uploads) качаются под настоящим именем через ?name;
   в S3 имя уже задано заголовком Content-Disposition. */
const IcDownload = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
);

export default function TaskFiles({ files, className = '', style }) {
  if (!Array.isArray(files) || files.length === 0) return null;
  return (
    <div className={`task-files ${className}`.trim()} style={style}>
      {files.map((f, i) => {
        const name = f.name || f.originalName || f.filename || 'Файл';
        const url = f.url || '';
        const href = url.includes('/uploads/') ? `${url}${url.includes('?') ? '&' : '?'}name=${encodeURIComponent(name)}` : url;
        const size = fmtSize(f.size);
        return (
          <a key={`${url}-${i}`} className="task-file" href={href} target="_blank" rel="noopener noreferrer" title={`Скачать «${name}»`}>
            <span className="task-file-ic" style={{ background: fileColor(name)[0], color: fileColor(name)[1] }}><FileIcon name={name} size={16} /></span>
            <span className="task-file-info">
              <span className="task-file-name">{name}</span>
              {size && <span className="task-file-size">{size}</span>}
            </span>
            <span className="task-file-dl" aria-hidden="true"><IcDownload /></span>
          </a>
        );
      })}
    </div>
  );
}
